import {
  FETCH_UPDATE_COMPNY_BY_ID_REQUEST,
  FETCH_UPDATE_COMPNY_BY_ID_SUCCESS,
  FETCH_UPDATE_COMPNY_BY_ID_FALUIRE,
} from './updateCompanyByIDTypes'

const initialState = {
  loading: false,
  updateCompanyByID: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_UPDATE_COMPNY_BY_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_UPDATE_COMPNY_BY_ID_SUCCESS : return {
      ...state,
      updateCompanyByID: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_UPDATE_COMPNY_BY_ID_FALUIRE : return {
      ...state,
      loading: false,
      updateCompanyByID: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
